export const BOARD_SETTINGS_CREATE_SWIMLANE_MODAL_ID = 'BOARD_SETTINGS_CREATE_SWIMLANE_MODAL_ID';
export const BOARD_SETTINGS_EDIT_SWIMLANE_MODAL_ID = 'BOARD_SETTINGS_EDIT_SWIMLANE_MODAL_ID';
export const BOARD_SETTINGS_DELETE_SWIMLANE_MODAL_ID = 'BOARD_SETTINGS_DELETE_SWIMLANE_MODAL_ID';
